<div class="layout-main">
  <div class="container-fluid">

    <div class="symbols-title-row">
      <h3 class="mb-0"><b>Exchanges</b></h3>
      <div class="search-wrapper">
        <i class="fa fa-search search-icon"></i>
        <input class="form-control search-input" type="text" placeholder="Search exchanges…"
               (input)="dt.filterGlobal($any($event.target).value, 'contains')">
      </div>
    </div>

    <div class="symbols-market-table">
      <p-table #dt [columns]="cols" [value]="exchangesList"
               [globalFilterFields]="['name']" [rowHover]="true">

        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of cols" [pSortableColumn]="col.sortable ? col.field : null"
                [style.width]="col.width">
              {{ col.header }}
              <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template let-exchange pTemplate="body">
          <tr>

            <td>
              <button [routerLink]="getDadConfigCrudLink(exchange)" class="exchange-link" type="button">
                {{ exchange?.name }}
              </button>
            </td>

            <td>{{ exchange?.dadConfig?.name }}</td>
            <td>{{ exchange?.dadConfig?.exchangeNameInTitle }}</td>
            <td class="num-cell">{{ exchange?.dadConfig?.creationDay }}</td>
            <td class="num-cell">{{ exchange?.dadConfig?.secondReminderDay }}</td>
            <td class="num-cell">{{ exchange?.dadConfig?.thirdReminderDay }}</td>
            <td class="num-cell">{{ exchange?.dadConfig?.quincyCutoffStartDay }}</td>
            <td class="num-cell">{{ exchange?.dadConfig?.quincyCutoffPeriod }}</td>

            <td>
              <ng-container *ngIf="exchange?.dadConfig">
                <span class="bool-badge" [class.bool-yes]="exchange.dadConfig.canAutoReport"
                      [class.bool-no]="!exchange.dadConfig.canAutoReport">
                  {{ exchange.dadConfig.canAutoReport ? 'Yes' : 'No' }}
                </span>
              </ng-container>
            </td>

            <td>
              <ng-container *ngIf="exchange?.dadConfig">
                <span class="bool-badge" [class.bool-yes]="exchange.dadConfig.canExempt"
                      [class.bool-no]="!exchange.dadConfig.canExempt">
                  {{ exchange.dadConfig.canExempt ? 'Yes' : 'No' }}
                </span>
              </ng-container>
            </td>

            <td>
              <ng-container *ngIf="exchange?.dadConfig">
                <span class="bool-badge" [class.bool-yes]="exchange.dadConfig.canCarryForward"
                      [class.bool-no]="!exchange.dadConfig.canCarryForward">
                  {{ exchange.dadConfig.canCarryForward ? 'Yes' : 'No' }}
                </span>
              </ng-container>
            </td>

            <td>
              <span *ngIf="exchange?.dadConfig?.reportType" class="report-type-badge">
                {{ exchange.dadConfig.reportType }}
              </span>
            </td>

            <td class="num-cell">{{ exchange?.dadConfig?.jumpCheckThreshold }}</td>

            <td>
              <ng-container *ngIf="exchange?.dadConfig">
                <span class="status-badge"
                      [class.status-active]="exchange.dadConfig.active"
                      [class.status-inactive]="!exchange.dadConfig.active">
                  {{ exchange.dadConfig.active ? 'Active' : 'Inactive' }}
                </span>
              </ng-container>
            </td>

            <td class="note-cell">{{ exchange?.dadConfig?.note }}</td>

          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td *ngIf="loadError" [colSpan]="cols.length" class="empty-message">
              <i class="fa fa-exclamation-triangle mr-2"></i>The exchanges could not be loaded. Please try again later.
            </td>
            <td *ngIf="!loadError" [colSpan]="cols.length" class="empty-message">
              <i class="fa fa-search mr-2"></i>No exchanges match your search.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>
</div>
